import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { NotificationCenterKeys } from "web_myplann/Api/NotificationCenter/notificationCenterKeys";
import {
	getNotificationCenterUpcomingV2,
	type TimelineHorizonEnum,
	type TimelineResponseDTO,
	type UpcomingTimelineItemTypeFilterEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponseQuery } from "web_myplann/Infrastructure/Api/ApiUtils";

const STALE_TIME_MS = 60_000;

interface UpcomingTimelinePreviewParams {
	horizon: TimelineHorizonEnum;
	type: UpcomingTimelineItemTypeFilterEnum;
	limit: number;
}

export const useUpcomingTimelinePreviewQuery = (
	params: UpcomingTimelinePreviewParams,
): UseQueryResult<TimelineResponseDTO, Error> => {
	return useQuery({
		queryKey: NotificationCenterKeys.upcomingPreview(
			params.horizon,
			params.type,
			params.limit,
		),
		queryFn: processResponseQuery(() =>
			getNotificationCenterUpcomingV2(
				params.horizon,
				params.type,
				undefined,
				undefined,
				undefined,
				params.limit,
			),
		),
		staleTime: STALE_TIME_MS,
	});
};
